import { useContext } from 'react';
import { TOOLTIP_ID } from '../constants';
import { HideTooltipContext, ShowTooltipContext } from '../provider/context';

/**
 * ツールチップの表示・非表示ハンドラーを取得する
 *
 * @example
 * const { showTooltip, hideTooltip, tooltipId } = useTooltip();
 * <button
 *   aria-describedby={tooltipId}
 *   onMouseEnter={(e) => showTooltip(e.currentTarget, 'help text')}
 *   onMouseLeave={hideTooltip}
 *   onFocus={(e) => showTooltip(e.currentTarget, 'help text')}
 *   onBlur={hideTooltip}
 * />
 */
export const useTooltip = () => {
  const { showTooltip } = useContext(ShowTooltipContext);
  const { hideTooltip } = useContext(HideTooltipContext);

  return { showTooltip, hideTooltip, tooltipId: TOOLTIP_ID };
};
